import { CloseAccountReasons } from '@afterpaytouch/portal-api/consumer/account/types'
import React, { createContext, Dispatch, FunctionComponent, SetStateAction, useState, ReactNode } from 'react'

export const noop = (): void => {}

export const CloseAccountFlowSteps = {
  SelectCloseAccountReason: 'SelectCloseAccountReason',
  SelectCloseAccountOption: 'SelectCloseAccountOption',
  ConfirmCloseAccount: 'ConfirmCloseAccount',
  DeactivateAccount: 'DeactivateAccount',
} as const

type CloseAccountFlowStepsType = typeof CloseAccountFlowSteps
type CloseAccountStepsKeys = keyof CloseAccountFlowStepsType
export type CloseAccountStepsProps = CloseAccountFlowStepsType[CloseAccountStepsKeys]

export interface CloseAccountFlowResult {
  success: boolean
  error: boolean
}
export interface CloseAccountFlowContextProps {
  show: boolean
  step: CloseAccountStepsProps
  setStep: Dispatch<SetStateAction<CloseAccountStepsProps>>
  resetState: () => void
  closeModal: () => void
  result: CloseAccountFlowResult
  setResult: Dispatch<SetStateAction<CloseAccountFlowResult>>
  closeAccountReason: CloseAccountReasons | null
  setCloseAccountReason: Dispatch<SetStateAction<CloseAccountReasons>>
}

const defaultStep = CloseAccountFlowSteps.SelectCloseAccountReason
export const defaultResult = { success: false, error: false }
export const closeAccountFlowContextDefaults: CloseAccountFlowContextProps = {
  show: false,
  step: defaultStep,
  setStep: noop,
  resetState: noop,
  closeModal: noop,
  result: defaultResult,
  setResult: noop,
  closeAccountReason: null,
  setCloseAccountReason: noop,
}

export const CloseAccountFlowContext = createContext<CloseAccountFlowContextProps>(closeAccountFlowContextDefaults)

export interface CloseAccountFlowProviderProps {
  show?: boolean
  closeModal: () => void
  initialStep?: CloseAccountStepsProps
  children: ReactNode
}

export const CloseAccountFlowModalProvider: FunctionComponent<CloseAccountFlowProviderProps> = ({ show = false, closeModal, children }) => {
  const [step, setStep] = useState<CloseAccountStepsProps>(defaultStep)
  const [closeAccountReason, setCloseAccountReason] = useState<CloseAccountReasons | null>(null)
  const [result, setResult] = useState<CloseAccountFlowResult>(defaultResult)

  const resetState = (): void => {
    setStep(defaultStep)
    setCloseAccountReason(null)
  }
  const value = {
    show,
    step,
    setStep,
    resetState,
    closeModal,
    result,
    setResult,
    closeAccountReason,
    setCloseAccountReason,
  }

  return <CloseAccountFlowContext.Provider value={value}>{children}</CloseAccountFlowContext.Provider>
}
